export const TEXT = {
  GOOGLE_LOGIN_CTA: {id: 'login.google.cta'},
};
